var _style, _g, _g2, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3KitDispatched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC15D;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#315DA7;}\n\t.st3{fill:#2A384F;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.7,182.9c42.7,0,77.3-34.3,77.3-76.6s-34.6-76.6-77.3-76.6S29.4,64,29.4,106.3S64,182.9,106.7,182.9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.4,92.2 106.8,108.8 146.4,92.2 106.9,75.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "106.9,75.1 94.5,63.8 66.9,75.6 59.2,78.8 54.8,80.7 67.4,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "106.9,75.1 119.5,64 159.8,80.9 146.4,92.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "146.2,102.3 146.2,137.1 106.7,153.4 106.7,108.8 106.6,108.8 121.3,109.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "106.8,108.9 106.8,153.1 66.7,135.8 66.7,102 91.9,109.1 106.7,108.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "146.4,92.2 159.2,103.5 119.3,120.3 106.8,108.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "106.8,108.8 94.6,120.3 66.8,108.6 59.2,105.4 54.8,103.5 67.4,92.2  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.8,120.3c0,0-0.2,0.1-0.4,0.3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "148.1,136.4 104.8,153.8 107.2,155.9 129.3,154.8 151.8,143 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3KitDispatched);
export default __webpack_public_path__ + "static/media/3KitDispatched.ccbb105f84b2d33dc50f9d84d5fe15ed.svg";
export { ForwardRef as ReactComponent };